import Vue from 'vue';
import { tsParticles } from 'tsparticles';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

// Iniitalize particles
tsParticles.loadJSON('tsparticles', '/js/particles.json');
